module.exports = __webpack_public_path__ + "img/move_sm.0d2a510e.png";